import { render, staticRenderFns } from "./leftbar.vue?vue&type=template&id=2bfa00d0&scoped=true"
import script from "./leftbar.vue?vue&type=script&lang=js"
export * from "./leftbar.vue?vue&type=script&lang=js"
import style0 from "./leftbar.vue?vue&type=style&index=0&id=2bfa00d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfa00d0",
  null
  
)

export default component.exports